import { render, staticRenderFns } from "./jhi-sidebar.vue?vue&type=template&id=aab7a9b0&scoped=true&"
import script from "./jhi-sidebar.component.ts?vue&type=script&lang=ts&"
export * from "./jhi-sidebar.component.ts?vue&type=script&lang=ts&"
import style0 from "./jhi-sidebar.vue?vue&type=style&index=0&id=aab7a9b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab7a9b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aab7a9b0')) {
      api.createRecord('aab7a9b0', component.options)
    } else {
      api.reload('aab7a9b0', component.options)
    }
    module.hot.accept("./jhi-sidebar.vue?vue&type=template&id=aab7a9b0&scoped=true&", function () {
      api.rerender('aab7a9b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/jhi-sidebar/jhi-sidebar.vue"
export default component.exports